export default __webpack_public_path__ + "static/media/lucio.ea94aec0.webp";